import { Component } from '@angular/core';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { Route } from '../../utils/route';
import { CitiesTabComponent } from "./cities-tab/cities-tab.component";
import { CountriesTabComponent } from "./countries-tab/countries-tab.component";
import { ProvincesTabComponent } from "./provinces-tab/provinces-tab.component";

@Component({
  selector: 'app-regions',
  imports: [TabsComponent, CitiesTabComponent, CountriesTabComponent, ProvincesTabComponent],
  templateUrl: './regions.component.html',
  styleUrl: './regions.component.scss',
})
export class RegionsComponent extends Route {}
